import React from "react";

import Job from "components/job";
import { Icons } from "components/layout";
import { Loader } from "components/request-result";
import CraftTypeLabel from "../../blocks/craft-type-label";
import { CUSTOM_CRAFT_TITLES_ENABLED } from "../../helpers/craft-title-helper";


const Wrap = ({
        action = () => {},
        wrapped,
        children
    }) => {

    if(wrapped){
        return (
            <button onClick={ action }>
                { children }
            </button>
        );
    }

    return (
        <>{ children }</>
    );
}

function toPascalCaseIconKey(type_icon) {
  return type_icon
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('') + 'Icon';
}

const CraftGridItem = ({
        extraClass,
        type,
        title,
        loading,
        count,
        craft_jobs = [],
        type_icon,
        hasJobType = [
            ...new Set(craft_jobs.map(item => item.type))
        ],
        ...props
    }) => {

    const comboTypes = ["claims", "customer_claims"];

    if(hasJobType.filter( item => comboTypes.indexOf(item) !== -1 ).length === 2){
        hasJobType = hasJobType.filter( item => comboTypes.indexOf(item) === -1);
        hasJobType.push("mp_and_customer_claims");
    }

    let CustomIcon = null;
    if (type_icon) {
        const iconKey = toPascalCaseIconKey(type_icon);
        CustomIcon = Icons.AdditionalCrafts[iconKey] || null;
    }

    return(
        <div className={ `craft-grid-item ${ extraClass }` }>
            { !loading ?
                <Wrap { ...props }>
                    { count !== undefined &&
                        <span className="count-tag">{ count }</span>
                    }
                    { hasJobType.map(
                        ( jobType ) => {


                            return (
                                <Job.Helpers.Tag
                                    jobType = { jobType }
                                    key = { `${props.id}_${jobType}` }
                                />
                            )
                        })
                    }
                    {CustomIcon ?
                        <CustomIcon /> :
                        <Icons.Craft type={ /\d/.test(type) ? type.replace(/_\d/g, '') : type } />
                    }
                    { (title || (CUSTOM_CRAFT_TITLES_ENABLED && title !== undefined)) &&
                        <span className="label">
                            <CraftTypeLabel
                                type={ type }
                                title={ title }
                                preferCustomTitle
                            />
                        </span>
                    }
                </Wrap> :
                <Loader />
            }
        </div>
    );
}

export default CraftGridItem;
